import Vue from "vue";
import { initProductVariantQuantity } from "../../../components/quantity";
import { QuantityInputMinicart } from "./quantityInputMinicart";
import { initTooltip } from "../../../components/toolTip";
import { loadLazyImages } from "../../../utilities/globalUtilities";

/**
 * MiniCart Item Component
 */
const MinicartItem = Vue.component("minicart-item", {
    template: `
    <div class="minicart-product-line" :class="{'d-none': !visible}" v-if="item.id != resources.plasticBagID">
        <div :class="['ct-minicart-tile minicart-product-row swipe-product-row', !isPriceAvailable || !item.online ? 'ct-minicart-tile--unavailable-tile' : '']"
            :data-pid="item.id"
            :data-confirmation-image='JSON.stringify(confirmationImage)'
            :data-delay-time="confirmationDelayTime"
            :data-product-name="productName"
            :data-in-cart-msg="resources.inCartLabel"
            :data-one-product-added="resources.inCartOneProduct"
            :data-remove-from-cart-msg="resources.removeFromCartLabel"
            :data-stay-open="resources.confirmationStayOpen">
            <div class="ct-minicart-inner-tile-wrap row no-gutters ct-slide-container">
                <div class="ct-minicart-top-details d-flex col-12 col-md-12 col-sm-6">
                    <div class="row w-100 no-gutters">
                        <div class="ct-minicart-image-container col-3">
                            <a :href="isPriceAvailable ? item.productURL : ''" class="product-link">
                                <picture class="intrinsic intrinsic--square" v-if="item.productTileImage && item.productTileImage.url && !item.noProduct">
                                    <img class="ct-product-image lazyload hidden"
                                        loading="lazy"
                                        @error="fallBackImageURL"
                                        :data-src="item.productTileImage.url"
                                        :alt="item.productTileImage.alt"
                                        :title="item.productTileImage.title"
                                        />
                                </picture>
                                <picture class="intrinsic intrinsic--square" v-else-if="!item.online">
                                    <img class="ct-product-image lazyload hidden"
                                        loading="lazy"
                                        :data-src="resources.undefinedProductImage"
                                        />
                                </picture>
                                <picture class="intrinsic intrinsic--square" v-else>
                                    <img class="ct-product-image lazyload hidden"
                                        loading="lazy"
                                        :data-src="resources.noImage"
                                        />
                                </picture>
                            </a>

                            <div :class="'ct-minicart-tile-badge ct-minicart-tile-badge--promotional ' + brandID + '-minicart-tile-badge'" v-if="isPriceAvailable && item.badgeInfo && item.badgeInfo.promo">
                                <img class="ct-minicart-badge img-fluid lazyload hidden"
                                    loading="lazy"
                                    :data-src="item.badgeInfo.promo.img"
                                    :alt="item.badgeInfo.promo.alt"
                                    :title="item.badgeInfo.promo.title"
                                />

                                <div v-if="item.badgeInfo.promo.showDiscountValue" :class="'ct-product-tile-badge-value-wrapper ct-product-tile-badge-value-wrapper--' + item.badgeInfo.promo.type + ' ' + brandID + '-product-tile-badge-value-wrapper ' + brandID + '-product-tile-badge-value-wrapper--' + item.badgeInfo.promo.type + (item.badgeInfo.promo.type == 'superprice' && item.badgeInfo.promo.showDiscountMessage ? ' ct-product-tile-badge-value-wrapper--with-text ' + brandID + '-product-tile-badge-value-wrapper--with-text' : '') + (item.badgeInfo.promo.floatValue ? ' ct-product-tile-badge-value-wrapper--float' : '')">
                                    <div class="ct-product-tile-badge-addition d-flex flex-column align-self-center text-center" v-if="item.badgeInfo.promo.showPlusDESignOnBadge">
                                        <span :class="'ct-product-tile-badge-addition--sign ' + brandID + '-product-tile-badge-addition--sign'">
                                            {{item.badgeInfo.promo.plusLabel}}
                                        </span>
                                        <span :class="'ct-product-tile-badge-addition--text ' + brandID + '-product-tile-badge-addition--text'">
                                            {{item.badgeInfo.promo.thanLabel}}
                                        </span>
                                    </div>
                                    <span :class="'ct-product-tile-badge-value--' + item.badgeInfo.promo.type + ' ' + brandID + '-product-tile-badge-value--' + item.badgeInfo.promo.type + (item.badgeInfo.promo.showPlusDESignOnBadge ? ' ' + brandID + '-product-tile-plusdesign' : '')">
                                        {{item.badgeInfo.promo.discount}}
                                    </span>
                                    <span :class="'ct-product-tile-badge-value--' + item.badgeInfo.promo.type + '-quantifier ' + brandID + '-product-tile-badge-value--' + item.badgeInfo.promo.type + '-quantifier' + (item.badgeInfo.promo.type == 'superprice' && item.badgeInfo.promo.showDiscountMessage ? ' d-none' : '') + (item.badgeInfo.promo.showPlusDESignOnBadge ? ' ' + brandID + '-product-tile-plusdesign' : '')">
                                        {{item.badgeInfo.promo.unit}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="ct-minicart-details pwc-ml--8 px-0 col-8">
                            <div class="ct-minicart-name-container">
                                <a :href="isPriceAvailable ? item.productURL : ''" class="pwc-tile--description ct-minicart-name mb-0">
                                    {{(!item.noProduct && item.productName) ? item.productName : resources.productNoName}}
                                </a>
                            </div>
                            <div v-if="!item.noProduct" class="ct-minicart-brand-container">
                                <span class="ct-minicart--brand">
                                    {{(item.brand)? item.brand : ""}}
                                </span>
                            </div>
                            <div class="ct-minicart-capacity-container" v-if="item.measurementNote">
                                {{item.measurementNote}}
                            </div>
                            <div class="ct-minicart--unavailable-message-container" v-if="item.noProduct || !item.online">
                                <p class="pwc-subtitle ct-minicart--unavailable-message">{{resources.priceUnavailable}}</p>
                            </div>
                            <div class="ct-minicart-swatches">
                                <span v-for="attribute in item.variationAttributes" :key="attribute.displayName">
                                    <p :class="'line-item-attributes ct-minicart-attributes ' + attribute.displayName + '-' + item.UUID"
                                        v-if="attribute && attribute.images && attribute.images['swatch']"
                                        >
                                        <span :data-attr-value="attribute.displayValue"
                                            :class="[attribute.id + '-value swatch-circle ct-minicart-swatch swatch-value', attribute.selected ? 'selected' : '']"
                                            :style="{'background-image': 'url(' + (attribute.images['swatch'].length > 0 ? attribute.images['swatch'][0].url : '') + ')'}"
                                        >
                                        </span>
                                    </p>

                                    <p :class="'line-item-attributes ct-minicart-attributes ct-minicart-size ' + attribute.displayName + '-' + item.UUID"
                                        v-else>
                                        {{attribute.displayValue}}
                                    </p>
                                </span>
                            </div>
                            <div v-if="item.online" :class="['ct-minicart-total-price', !isPriceAvailable ? 'd-block d-md-block' : 'col-auto']" :data-pid="item.id">
                                <p :class="['ct-minicart-total totalPrice ct-subtitle', !isPriceAvailable ? 'ct-minicart--unavailable-message' : 'd-none']">
                                    {{(isPriceAvailable) ? item.priceTotal.price : resources.priceUnavailable}}
                                </p>
                            </div>
                            <div class="dual-badge" v-for="messageDualBadge in promotionsDualBadgeMessages">
                                <div class="dual-badge-message">
                                    <span class="dual-badge-message-text">{{messageDualBadge}}</span>
                                </div>
                                <span class="dual-badge-arrow"></span>
                                <br>
                            </div>
                        </div>
                        <div class="ct-minicart-remove col pr-0 text-right d-none d-md-block">
                            <button type="button"
                                class="minicart-remove-product"
                                :data-pid="item.id"
                                :data-uuid="item.UUID"
                                :data-action="resources.removeProductAction"
                                :data-undo-delay="resources.undoProductRemovalDelay"
                                data-toggle="tooltip"
                                data-placement="right"
                                :aria-label="resources.removeProductLabel"
                                :title="resources.trashTooltip"
                                >
                                <span v-html="trashIcon" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="ct-minicart-qty-wrapper ct-minicart-bottom-details col-12 col-md-12 col-sm-6">
                    <div :class="['row no-gutters d-flex ct-minicart-qty-block', !isPriceAvailable? '' : 'justify-content-between']">
                        <div class="ct-minicart-qty col-6 col-s-5 col-sm-6 col-md-8" v-if="isPriceAvailable && item.online">
                            <div class="ct-tile-quantity">
                                <quantity-input-minicart :item="item" :resources="resources" :quantityInputIcons="quantityInputIcons" />
                            </div>
                        </div>
                        <div v-if="item.online" :class="['ct-minicart-total-price', !isPriceAvailable ? 'offset-3 offset-md-3 col-8 d-block d-sm-none d-md-block' : 'col-auto']" :data-pid="item.id">
                            <p :class="['ct-minicart-total totalPrice pwc-subtitle', !isPriceAvailable ? 'text-uppercase d-none ct-minicart--unavailable-message' : '']">
                                {{(isPriceAvailable) ? item.priceTotal.price : resources.priceUnavailable}}
                            </p>
                        </div>
                        <div :class="['ct-minicart-remove col-auto px-0', !isPriceAvailable ? 'offset-sm-11 ml-auto' : '']">
                            <button type="button" class="minicart-remove-product"
                                :data-pid="item.id"
                                :data-uuid="item.UUID"
                                :data-action="resources.removeProductAction"
                                :data-undo-delay="resources.undoDelayTime"
                                :aria-label="resources.removeProductLabel"
                                >
                                <span v-html="trashIcon" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="swipe-remove col-auto px-0 d-none d-sm-none d-md-none ct-minicart-remove-mobile">
                <button type="button" class="minicart-remove-product"
                    :data-pid="item.id"
                    :data-uuid="item.UUID"
                    :data-action="resources.removeProductAction"
                    :data-undo-delay="resources.undoDelayTime"
                    :aria-label="resources.removeProductLabel"
                    >
                    <span v-html="trashIcon" />
                </button>
            </div>
        </div>

        <div class="ct-remove-product ct-remove-container ct-product-removed d-none" :data-pid="item.id">
            <p class="ct-removed-label">{{resources.productRemoved}}</p>
            <a class="undo-remove ct-remove-undo" role="button"
                :href="resources.undoProductRemovalAction"
                :data-pid="item.id"
                >
                {{resources.undoProductRemovalText}}
            </a>
        </div>
    </div>
    `,
    props: ["resources", "item", "trashIcon", "quantityInputIcons", "brandID", "visible"],
    computed: {
        confirmationImage: function () {
            return this.item.confirmationImage;
        },
        confirmationDelayTime: function () {
            return this.item.confirmationDelayTime;
        },
        productName: function () {
            return this.item.productName;
        },
        promotionsDualBadgeMessages: function () {
            let dualBadgeMessages = [];
            if (this.item.promotions) {
                this.item.promotions.forEach(element => {
                    if (element.dualBadgeMessage) {
                        dualBadgeMessages.push(element.dualBadgeMessage);
                    }
                });
            }
            return dualBadgeMessages;
        }
    },
    data: function () {
        return {
            isPriceAvailable: (this.item.online && this.item.price && this.item.price.sales.value > 0 && this.item.priceTotal.value > 0),
            qtyInputHtml: this.item.qtyInputHtml
        };
    },
    methods: {
        fallBackImageURL: function (e) {
            e.target.src = this.resources.noImage;
        }
    },
    mounted() {
        initProductVariantQuantity(this.item.id, ".minicart");
        initTooltip(".ct-popover");
        loadLazyImages(`.ct-minicart-tile[data-pid="${this.item.id}"]`);
    },
    components: {
        QuantityInputMinicart
    }
});

export { MinicartItem };
